/** A bitmask of mute states.
 * @example <caption>Audio can be muted locally and/or remotely, which could be represented as:</caption>
 * MUTES.PLAYBACK | MUTES.MICROPHONE
 */
export default {
  NONE: 0,
  PLAYBACK: 2 ** 0,
  MICROPHONE: 2 ** 1,
};
